import getStore from '../data/store/store';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';

/**
 * Utility function to log the usage of options.
 */
export default function logDataOnSaveInvitations() {
    let currentState = getStore();
    if (!currentState) {
        return;
    }
    logDeleteForwardedEventsStatus();
    logDeleteUpdatedInvitationsStatus();
}

function logDeleteForwardedEventsStatus() {
    let currentState = getStore();
    if (currentState.removeForwardedMeetingNotifications != null) {
        const customData = datapoints.DeleteForwardedEventsNotificationOnOffStatus.datapoint.customData(
            currentState.removeForwardedMeetingNotifications
        );
        logUsage(
            datapoints.DeleteForwardedEventsNotificationOnOffStatus.datapoint.name,
            customData
        );
    }
}

function logDeleteUpdatedInvitationsStatus() {
    let currentState = getStore();
    if (currentState.removeOldMeetingMessages != null) {
        const customData = datapoints.DeleteUpdatedInvitationsOnOffStatus.datapoint.customData(
            currentState.removeOldMeetingMessages
        );
        logUsage(datapoints.DeleteUpdatedInvitationsOnOffStatus.datapoint.name, customData);
    }
}
